// src/PaymentSuccess.js
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handlePaymentSuccess } from './creditManager';
import Layout from './components/Layout';

const translations = {
  en: {
    title: "Payment Successful!",
    message: "Your credits have been added to your account.",
    redirecting: "Taking you back to the unlock tool in a moment...",
  },
  ja: {
    title: "支払い成功！",
    message: "クレジットがアカウントに追加されました。",
    redirecting: "まもなくロック解除ツールに戻ります...",
  },
  mn: {
    title: "Төлбөр амжилттай!",
    message: "Таны кредитүүд таны дансанд нэмэгдлээ.",
    redirecting: "Таныг түгжээ тайлах хэрэгсэл рүү буцааж байна...",
  },
  ur: {
    title: "ادائیگی کامیاب!",
    message: "آپ کے کریڈٹس آپ کے اکاؤنٹ میں شامل کر دیے گئے ہیں۔",
    redirecting: "آپ کو ابھی ان لاک ٹول پر واپس لے جایا جائے گا...",
  },
  ru: {
    title: "Платеж успешен!",
    message: "Кредиты добавлены в вашу учетную запись.",
    redirecting: "Сейчас вы будете перенаправлены обратно к инструменту...",
  },
};

function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const packageId = searchParams.get('package');
  const lang = searchParams.get('lang') || 'en';
  const t = translations[lang] || translations.en;
  useEffect(() => {
    if (packageId) handlePaymentSuccess(packageId);

    const timer = setTimeout(() => {
      navigate(lang === 'en' ? '/' : `/${lang}/`);
    }, 4000);

    return () => clearTimeout(timer);
  }, [packageId, navigate, lang]);

  return (
    <Layout language={lang}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '40px 16px',
        textAlign: 'center',
      }}>
        <div style={{
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: 16,
          padding: '48px 40px',
          maxWidth: 420,
          width: '100%',
          boxShadow: '0 4px 24px rgba(37,99,235,0.08)',
        }}>
          {/* Success checkmark */}
          <div style={{
            width: 72,
            height: 72,
            background: '#dcfce7',
            border: '3px solid #16a34a',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 36,
            margin: '0 auto 24px',
          }}>
            ✓
          </div>

          <h1 style={{ color: '#1e3a8a', fontSize: 24, marginBottom: 12 }}>{t.title}</h1>
          <p style={{ color: '#374151', fontSize: 16, marginBottom: 28 }}>{t.message}</p>

          {/* Spinner + redirecting text */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, color: '#6b7280', fontSize: 14 }}>
            <svg
              width="18" height="18" viewBox="0 0 24 24"
              style={{ animation: 'spin 1s linear infinite', flexShrink: 0 }}
            >
              <circle cx="12" cy="12" r="10" fill="none" stroke="#d1d5db" strokeWidth="3" />
              <path d="M12 2a10 10 0 0 1 10 10" fill="none" stroke="#2563eb" strokeWidth="3" strokeLinecap="round" />
            </svg>
            <span>{t.redirecting}</span>
          </div>
        </div>

        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </Layout>
  );
}

export default PaymentSuccess;
